import { withStyles } from "@mui/styles";
import {  FormattedMessage, injectIntl } from "react-intl";
import { Styles } from '../../../../styles/material-styles';
import { Autocomplete, Button, Chip, Container, Grid, TextField } from "@mui/material";
import * as LLMEventService from "../../../../services/llmevent.service.js";
import * as LLMKeyWordService from "../../../../services/llmkeyword.service.js";
import { useEffect, useState } from "react";
import { NotificationVariant } from "src/utils/enums/notification-variants.enum";
import SimpleAutoComplete from "src/components/auto-complete/autocomplete.js";
import LlmKeyWordList from "./llm-key-word-list";

const LlmKeyWordComponent = (props) => {

    const { classes, intl, llm, onShowNotification, onLoading } = props;

    const [llmEvents, setLlmEvents] = useState([]);
    const [llmEventSelected, setLlmEventSelected] = useState(null);

    const [keyWords, setKeyWords] = useState([]);

    const [llmKeyWordsSaved, setLlmKeyWordsSaved] = useState([]);

    const handleChangeAutoComplete = (value) => {  
        setLlmEventSelected(value ?? null);
    }

    const formValidation = () => {
        if (keyWords?.length === 0) {
            onShowNotification("É necessário informar pelo menos uma palavra-chave.", NotificationVariant.ERROR);
            return false;
        }

        return true;
    }

    const handleSubmit = async (event) => {
        onLoading(true);
        event.preventDefault();

        try {
            if(formValidation() === true) { 

                const payload = {
                    llmId: llm?.id,
                    llmEventId: llmEventSelected?.id,
                    keyWords
                };

                const response = await LLMKeyWordService.create(payload);

                if (response?.success === true) {
                    onShowNotification(intl.formatMessage({ id: "add.success" }));
                    setKeyWords([]);
                    await fetchLLMKeyWords();
                } else {
                    onShowNotification("Não foi possível obter os eventos de llm.", NotificationVariant.ERROR);
                }
                
            }
        } catch (err) {
            onShowNotification("Não foi possível obter os eventos de llm.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const fetchLLMKeyWords = async () => {
        onLoading(true);

        try {
            const response = await LLMKeyWordService.getAllLLMKewWordEventSystem(llm?.id);

            if (response?.success === true) {
                setLlmKeyWordsSaved(response?.data ?? []);
            } else {
                onShowNotification("Não foi possível obter as palavras chaves desse evento.", NotificationVariant.ERROR);
            }
        } catch (err) {
            onShowNotification("Não foi possível obter as palavras chaves desse evento.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const fetchEvents = async () => {
        onLoading(true);

        try {
            const response = await LLMEventService.getAllEventSystem();

            if (response?.success === true) {
                setLlmEvents(response?.data ?? []);
            } else {
                onShowNotification("Não foi possível obter os eventos.", NotificationVariant.ERROR);
            }
        } catch (err) {
            onShowNotification("Não foi possível obter os eventos.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const loadInitialStateComponent = async () => {
        await Promise.all([
            fetchEvents(),
            fetchLLMKeyWords()
        ]);
    }

    useEffect(() => {
        loadInitialStateComponent();
    }, []);

    return (
        <div style={{ paddingTop: '8px' }}>
          <Container component='main' maxWidth='lg'>
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <form name='myForm' className={classes.form} onSubmit={handleSubmit} encType='multipart/form-data'>
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={12}>
                        <SimpleAutoComplete
                            name="llmEvent"
                            label={intl.formatMessage({ id: "event" })}
                            options={llmEvents}
                            stateName='llmEvent'
                            changeSelect={(stateName, value) => {
                                handleChangeAutoComplete(value)
                            }}
                            selected={llmEventSelected}
                            htmlOptions={true}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Autocomplete
                            multiple
                            id="tags-filled"
                            options={[]}
                            freeSolo
                            value={keyWords}
                            onChange={(event, newValue, reason) => {
                                setKeyWords(newValue);
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                    const { key, ...tagProps } = getTagProps({ index });
                                    return <Chip variant="outlined" label={option} key={key} {...tagProps} />;
                                })
                            }
                            renderInput={(params) => (
                                <TextField {...params} variant="filled" label={intl.formatMessage({ id: "keywords" })} />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                      <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                        <Grid item xs={12} sm={4}    >
                          <Button
                            type='submit'
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={classes.submit}
                          >
                            {<FormattedMessage id="save" />}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                </Grid>
              </form>   
            </div>  

            <div style={{ paddingTop: '8px' }}>
                <LlmKeyWordList
                    data={llmKeyWordsSaved}
                    onShowNotification={onShowNotification}
                    onLoading={onLoading}
                />
            </div>
          </Container>
      </div>
    )
}

export default injectIntl(withStyles(Styles)(LlmKeyWordComponent));